import createVueComponent from '../createVueComponent';

const CloudFog = createVueComponent('CloudFogIcon', [
  ['path', { d: 'M20 16.2A4.5 4.5 0 0017.5 8h-1.8A7 7 0 104 14.9' }],
  ['path', { d: 'M16 17H7' }],
  ['path', { d: 'M17 21H9' }],
]);

export default CloudFog;
